class PlugSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!window.Swiper) {
            console.error("PLUG: Swiper.js is not loaded. Please include Swiper.js to use the plug-logo-bar component.");
            return this.hideSection();
        }

        this.sliderId = this.dataset.sliderId;

        this.elements = {
            swiper: document.getElementById(this.sliderId),
            swiperWrapper: this.querySelector(".swiper-wrapper"),
            slides: this.querySelectorAll(".swiper-slide"),
        };

        if (!this.sliderId || !this.elements.swiper) {
            console.error("PLUG: Swiper element cannot be found.");
            return this.hideSection();
        }

        this.initSlider();
    }

    initSlider() {
        const defaultSettings = {
            a11y: true,
            centerInsufficientSlides: true,
            grabCursor: true,
            slidesPerView: "auto",
        };

        const settingsScript = this.querySelector("script[data-slider-custom-settings]");
        const customSettings = (
            settingsScript
                ? JSON.parse(settingsScript.innerHTML)
                : {}
        );

        this.swiper = new Swiper(
            `#${this.sliderId}`,
            Object.assign(defaultSettings, customSettings)
        );
    }

    disconnectedCallback() {
        if (this.swiper && typeof this.swiper.destroy === "function") {
            this.swiper.destroy();
        }
    }

    hideSection() {
        const section = this.closest(".plug-section");
        if (section) {
            section.style.display = "none";
        }
    }
}

if (!customElements.get("plug-slider")) {
    customElements.define("plug-slider", PlugSlider);
}
